// extracted by mini-css-extract-plugin
module.exports = {"btn":"ApplyButton_btn__GI1IG"};